export default __webpack_public_path__ + "static/media/img-banner04.014aa329.png";